import { Message } from 'gsum-uikit-vue'
import store from '../vuex/store'
import cookie from 'vue-cookie'

// 公用方法
export const globalService = {
  pageSetting: {
    page: 1,
    pageSize: 10,
    total: 0,
    pageSizes: [10, 15, 20]
  },

  // 跳转页面
  linkPage: function (navItem, page) {
    if (navItem.url) {
      window.location.href = navItem.url
    } else {
      page.$router.push({
        path: '/' + navItem.route
      })
    }
  },
  // 格式化开始时间
  queryBeginFormat: function (date) {
    return window.moment(date).format('YYYY-MM-DD 00:00:00')
  },
  // 格式化结束时间
  queryEndFormat: function (date) {
    var endTime = window.moment(date)
    if (endTime.isSame(window.moment(), 'day')) {
      return window.moment().format('YYYY-MM-DD HH:mm:ss')
    } else {
      return endTime.format('YYYY-MM-DD 23:59:59')
    }
  },
  showErrNofify: function (response) {
    var errInfo = ''
    if (Object.prototype.toString.call(response) === '[object String]') {
      errInfo = response
    } else if (Object.prototype.toString.call(response) === '[object Object]') {
      errInfo = response.data ? response.data.Message : ''
    }
    if (errInfo) {
      Message({
        type: 'error',
        title: '错误',
        message: errInfo,
        position: 'bottom-left',
        duration: 1000
      })
    }
  },
  showNofify: function (type, title, response, time = 3000) {
    var errInfo = ''
    if (Object.prototype.toString.call(response) === '[object String]') {
      errInfo = response
    } else if (Object.prototype.toString.call(response) === '[object Object]') {
      errInfo = response.data ? response.data : ''
    }
    if (errInfo) {
      Message({
        type: type,
        title: title,
        message: errInfo,
        position: 'bottom-left',
        duration: time
      })
    }
  },
  checkAuth: function (moduleId) {
    var userInfo = JSON.parse(cookie.get('userInfo')) ? JSON.parse(cookie.get('userInfo')) : {}
    var userPermission = userInfo ? userInfo.SystemPermission : []
    var perDic = globalService.getPerimissionDic(userPermission)

    if (!perDic[moduleId]) {
      globalService.showErrNofify('您无此页面访问权限！ ')
      setTimeout(function () {
        window.location.href = '/'
      }, 2000)
    }
  },
  getUserAuthDic: function (userInfoData) {
    var userInfo = JSON.parse(cookie.get('userInfo'))
    var userPermission = userInfo ? userInfo.SystemPermission : []
    var perDic = globalService.getPerimissionDic(userPermission)
    console.log(perDic)
    return perDic
  },
  // 获取权限字典
  getPerimissionDic: function (userPermission) {
    var perDic = {}
    userPermission.forEach(function (item) {
      perDic[item.Id] = item.Enable
      if (item.Children) {
        perDic = Object.assign(
          perDic,
          globalService.getPerimissionDic(item.Children)
        )
      }
    })
    return perDic
  },
  formatDateTime: function (date) {
    // console.log(window.moment(date).format('YYYY-MM-DD HH:mm:ss'))
    return window.moment(date).format('YYYY-MM-DD HH:mm:ss')
  },
  trimBlank: function (str) {
    return str.replace(/^\s*|\s*$/g, '')
  },
  showArticle: function (articleId, pageObj) {
    // 打开新页面
    window.open('./index.html#/article/' + articleId)

    // 弹窗显示正文
    // let url = dataUrl.History.article.replace('{id}', articleId)
    // service.historyEventService.loadColums(url).then(res => {
    //   pageObj.articleData = res.data
    //   pageObj.dialogShow.show = true
    // })
  },
  strlen: function (str) {
    var len = 0
    for (var i = 0; i < str.length; i++) {
      var c = str.charCodeAt(i)
      // 单字节加1
      if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
        len++
      } else {
        len += 2
      }
    }
    return len
  },
  getPrimaryKeyArray (array, key) {
    let dist = []
    array.forEach(item => {
      dist.push(item[key])
    })
    return dist
  }
}



// WEBPACK FOOTER //
// ./src/service/globalService.js